import React from 'react';
import { CalendarSvg } from './Assets/CalendarSvg';
import styled from 'styled-components';
import { MarkdownPreview } from './MarkdownPreview';

const CalendarDescription = styled.div`
  color: #333;
  font-family: 'Lato', sans-serif;
  font-size: 1em;
  line-height: 1.375em;
  word-break: break-all;
`;

export function LeftCalendar(props: {descriptionText: string, title: string,description: any, color: string}) {
  return (
    <div>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <h1>{props.title}</h1>
      </div>
      <a href={'https://www.munikum.no'} target={'_blank'} rel="noopener noreferrer">
        <CalendarSvg color={props.color}/>
      </a>
      <h2>Skildring</h2>
      <CalendarDescription>
        {props?.descriptionText === '' ?
          <div style={{paddingLeft: '10px', fontStyle: 'italic', opacity: 0.7 }}>
            Formål er ikkje skildra
          </div> :
          <MarkdownPreview description={props.description}/>
        }
      </CalendarDescription>
    </div>
  );

}